export default __webpack_public_path__ + "static/media/img1.02a871bd.png";